type LocaleJson = Record<string, unknown>;

export const fetchLocaleFromAssets = async (locale: string): Promise<LocaleJson> => {
  try {
    const data = await import(`../../assets/locales/${locale}/${locale}.json`);
    return data.default as LocaleJson;
  } catch (err) {
    console.error('Fetching locale from assets had this issue, ', err);
    throw new Error(`Failed to load ${locale}.json`);
  }
};
